export default __webpack_public_path__ + "static/HeroImageBackground-12f8f54c1203f94fc4a3091b57e1cb9b.jpg";